import { SELECTED_REPORT_CHANGED, SET_IS_AGGREGATED, INITIALISE_REPORT_NAME, INITILISE_REPORT_DESCRIPTION,
    RESET_REPORT_NAME_AND_DESCRIPTION_AND_ID,SUGGESTED_FILTER, UPSERT_SUGGESTED_FILTER,
    INITIALISE_REPORT_ID,COLUMN_NAME,
    SELECTED_DBTYPE_CHANGED,
    SET_OBJECT,
    INITIALISE_OBJECT,
    RESET_OBJECT,
    INITIALISE_REPORT_CATEGORY,
    UPDATE_REPORT_NAME,
    INITILISE_METRIC_TYPE,
    DUMMY_DATA_SWITCH,
    CUSTOM_QUERY_STRING,
    UNDERLYING_CUSTOM_QUERY_STRING,
    CHANGE_METRIC_STRING_MANUAL_QUERY,
    CHANGE_MONGO_COLLECTION_NAME,
    ADMIN_REPORT_SWITCH,
    SELECTED_DATA_MART_TYPE_CHANGED,
    SET_REPORT_TIMEZONE,
    SET_REPORT_FROZEN_STATE,
} from '../reduxActions/actionNameEnums';

const initialState = {
    isAggregated: false,
    reportName: '',
    reportDescription: '',
    metricType: '',
    queryString: '',
    underlyingQueryString: '',
    metricString: '',
    isAdminReport: false,
    suggestedFilterStrings: [] as Array<{ key: string; value: string[] }>,
    timezone: null,
    // Per-report lock. Mirrors the freeze fields on getReportById so the save
    // surfaces can disable editing without another lookup. canManageFreeze is the
    // backend-computed canManageReportFilters flag - whether the current user may
    // lock/unlock and edit this report while it is locked.
    // frozenBy is the locker's display name, not their userId, so it is safe to
    // render as-is. The backend keeps the unfreeze audit private.
    isFrozen: false,
    frozenBy: null,
    frozenAt: null,
    canManageFreeze: false,
};

const reportReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch(type){
        case SELECTED_REPORT_CHANGED:
            return {
                ...state,
                selectedReport: payload,
            };
        case SELECTED_DBTYPE_CHANGED:
            return {
                ...state,
                selectedDbType: payload,
            };
        case SET_IS_AGGREGATED:
            return {
                ...state,
                isAggregated: payload,
            };
        case INITILISE_REPORT_DESCRIPTION:
            return {
                ...state,
                reportDescription: payload,
            };
        case INITIALISE_REPORT_NAME:
            return {
                ...state,
                reportName: payload,
            };
        case UPDATE_REPORT_NAME:
            return {
                ...state,
                reportName: payload,
            };
        case INITIALISE_REPORT_ID:
            return {
                ...state,
                reportID: payload,
            };
        case RESET_REPORT_NAME_AND_DESCRIPTION_AND_ID:
            return {
                ...state,
                reportID: '',
                reportName: '',
                reportDescription: '',
                timezone: null,
                isFrozen: false,
                frozenBy: null,
                frozenAt: null,
                canManageFreeze: false,
            };
        case SUGGESTED_FILTER:
            return {
                ...state,
                suggestedFilterStrings: payload,
            };
        case UPSERT_SUGGESTED_FILTER:
            return {
                ...state,
                suggestedFilterStrings: [
                    ...(state.suggestedFilterStrings || []).filter((s) => s.key !== payload.key),
                    payload,
                ],
            };
        case SET_OBJECT:
            return {
                ...state,
                object: {
                    ...state['object'],
                    ...payload,
                },
            };
        case RESET_OBJECT:
            return {
                ...state,
                object: {},
            };
        case INITIALISE_OBJECT:
            return {
                ...state,
                object: payload,
            };
        case COLUMN_NAME:
            return {
                ...state,
                columnName: payload,
            };
        case INITIALISE_REPORT_CATEGORY:
            return {
                ...state,
                reportCategory: payload,
            };
        case INITILISE_METRIC_TYPE:
            return {
                ...state,
                metricType: payload,
            };
        case DUMMY_DATA_SWITCH:
            return {
                ...state,
                dummyDataSwitch: payload.enableDummyData,
            };
        case CUSTOM_QUERY_STRING:
            return {
                ...state,
                queryString: payload.queryString,
            };
        case UNDERLYING_CUSTOM_QUERY_STRING:
            return {
                ...state,
                underlyingQueryString: payload.queryString,
            };
        case CHANGE_METRIC_STRING_MANUAL_QUERY:
            return {
                ...state,
                metricString: payload.metricString,
            };
        case ADMIN_REPORT_SWITCH:
            return {
                ...state,
                isAdminReport: payload.isAdminReport,
            };
        case SELECTED_DATA_MART_TYPE_CHANGED:
            return {
                ...state,
                dataMartType: payload,
            };
        case CHANGE_MONGO_COLLECTION_NAME:
            return {
                ...state,
                mongoCollectionName: payload,
            };
        case SET_REPORT_TIMEZONE:
            return {
                ...state,
                timezone: payload,
            };
        case SET_REPORT_FROZEN_STATE:
            return {
                ...state,
                isFrozen: !!payload?.isFrozen,
                frozenBy: payload?.frozenBy ?? null,
                frozenAt: payload?.frozenAt ?? null,
                // Only the report load carries the capability flag; a lock/unlock
                // toggle omits it, so preserve the value already in state then.
                ...(payload && 'canManageFreeze' in payload
                    ? { canManageFreeze: !!payload.canManageFreeze }
                    : {}),
            };
        default:
            return state;
    }
};

export default reportReducer;
